import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { TuiNotificationModule } from '@taiga-ui/core/components/notification';
import { tuiAsAlerts } from '@taiga-ui/cdk';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastService } from './toast.service';
import { ToastComponent } from './toast.component';

@NgModule({
  imports: [ CommonModule, PolymorpheusModule, TuiNotificationModule, TranslateModule ],
  declarations: [ ToastComponent ],
  exports: [ ToastComponent ],
  providers: [ tuiAsAlerts(ToastService) ],
})
export class ToastModule {}
